import LogsTab from "../../../../docs/_images/logs_tab.png";
import * as React from 'react';
export default {
  LogsTab,
  React
};